// "How is this calculated?" content for the Cache value (GET-266). It is
// shown on its own screen (CacheValueExplainerScreen, route
// "CacheValueExplainer"), which screens open from ValueBlock's
// onHowCalculatedPress.
//
// Copy rules (product rules 0/1): name no price source, give no counts,
// show no range or low/median/high, and mention no model internals. The
// wording is the owner-approved draft; edit it here only.

import React, { useMemo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useTheme } from '../../styles/ThemeProvider';

export const CACHE_VALUE_EXPLAINER_TITLE = 'How Cache values your item';

export const CACHE_VALUE_EXPLAINER_SECTIONS: readonly { heading: string; body: string }[] = [
  {
    heading: 'What it is.',
    body: 'Cache value is what your exact model is worth today in used condition.',
  },
  {
    heading: 'How we work it out.',
    body: "We look at recent prices for the same model and variant, set aside ones that don't match, and update the value as prices change.",
  },
  {
    heading: "What it isn't.",
    body: "It's not an offer or a guaranteed sale price.",
  },
  {
    heading: 'No value yet?',
    body: 'When we don\'t have enough reliable prices for a model, we show "No value yet" rather than guess.',
  },
];

export function CacheValueExplainer() {
  const theme = useTheme();
  const styles = useMemo(
    () =>
      StyleSheet.create({
        title: {
          ...theme.typography.h4,
          color: theme.colors.textPrimary,
          marginBottom: theme.spacing.xl,
        },
        section: { marginBottom: theme.spacing.lg },
        heading: {
          ...theme.typography.md,
          fontFamily: theme.fontFamily.bodyMedium,
          color: theme.colors.textPrimary,
          marginBottom: theme.spacing.xs,
        },
        body: { ...theme.typography.md, color: theme.colors.textSecondary },
      }),
    [theme]
  );

  return (
    <View>
      <Text style={styles.title} accessibilityRole="header">
        {CACHE_VALUE_EXPLAINER_TITLE}
      </Text>
      {CACHE_VALUE_EXPLAINER_SECTIONS.map(({ heading, body }) => (
        <View key={heading} style={styles.section}>
          <Text style={styles.heading} accessibilityRole="header">
            {heading}
          </Text>
          <Text style={styles.body}>{body}</Text>
        </View>
      ))}
    </View>
  );
}

export default CacheValueExplainer;
